<template>
    <span :class="linkClass" @click.prevent="onClick">{{ linkText }}</span>
</template>

<script>
import { mapActions } from "vuex";
import { API_ROUTES } from "../api";

export default {
    props: {
        linkText: String,
        linkClass: String,
    },
    methods: {
        ...mapActions({
            logout: "auth/logout",
        }),
        onClick: function () {
            this.$api
                .get(API_ROUTES.LOGOUT_AUTH0)
                .then(() => {
                    this.logout();
                    this.$router.push({ name: "login" });
                })
                .catch(({ response: { data } }) => {
                    let message = data.message ?? "Failed to process logout";
                    this.$bvToast.toast(message, {
                        title: "ERROR",
                        variant: "danger",
                    });
                });
        },
    },
};
</script>
